module.exports = __webpack_public_path__ + "media/packs/images/flags/TZ-63b5c11b9d23512d668aafd9a579242d.png";